import type { Ref } from 'vue';
import { computed, ref, watch } from 'vue';
import { defineContext } from '@/core/lib/defineContext';
import type { IMpCombination, IMpCombinationLoaded } from '@/interface/IPopularMixParlay';

export const MpCombinationsContext = defineContext('MpCombinations', (mpCombinations: Ref<IMpCombination[]>) => {
    const validMpCombinations = ref<IMpCombinationLoaded[]>(formatMpCombinations(mpCombinations.value));

    function formatMpCombinations(mpCombinations: IMpCombination[]): IMpCombinationLoaded[] {
        return mpCombinations.map(mp => formatMpCombination(mp));
    }

    function formatMpCombination(mpCombination: IMpCombination): IMpCombinationLoaded {
        return {
            ...mpCombination,
            subBetKeys: mpCombination.subBetKeys ?? [],
            loaded: false,
        };
    }

    watch(mpCombinations, (newValue) => {
        const updatedCombinations = newValue.map((newCombination) => {
            const existingCombination = validMpCombinations.value.find(existing => existing.key === newCombination.key);
            return existingCombination ?? formatMpCombination(newCombination);
        });
        validMpCombinations.value = updatedCombinations;
    });

    function removeMpCombination(key: string) {
        validMpCombinations.value = validMpCombinations.value.filter(mp => mp.key !== key);
    }

    function updateMpCombinationLoaded(key: string) {
        const mpToUpdate = validMpCombinations.value.find(mp => mp.key === key);
        if (!mpToUpdate) {
            return;
        }
        mpToUpdate.loaded = true;
    }

    const isAllLoaded = computed(() => validMpCombinations.value.length > 0 && validMpCombinations.value.every(x => x.loaded));

    return {
        isAllLoaded,
        validMpCombinations,
        removeMpCombination,
        updateMpCombinationLoaded,
    };
});
